// @flow
import React, { Component } from "react";

import styles from "./index.module.css";

class ComponentTraceLoader extends Component {
  render() {
    const { columnConfig = [], length = 0, type } = this.props;

    switch (type) {
      case "buildViewInfinte":
        return (
          <div className={`${styles.traceParent}`}>
            {[1, 2, 3].map((_, index) => {
              return (
                <div
                  className="timeline-wrapper"
                  key={`buildViewInfinite-${index}`}
                >
                  <div className={`${styles.timeline_item}`}>
                    <div
                      className={`${styles["traceCol-2"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.buildViewDate}`}
                      />
                      <div
                        className={`${styles.baseStyle} ${styles.buildViewTime}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-5"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.buildViewName}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-3"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.buildViewSummary}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-2"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.buildViewStatus}`}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      case "firstLoad":
        return (
          <div className={`${styles.traceParent}`}>
            <div>
              <div className={`${styles.timeline_tabs}`}>
                {" "}
                <div
                  className={`${styles.baseStyle} ${styles.buildViewDate}`}
                />
              </div>
              <div className={`${styles.timeline_tabs}`}>
                <div
                  className={`${styles.baseStyle} ${styles.buildViewDate}`}
                />
              </div>
              <div className={`${styles.timeline_tabs}`}>
                <div
                  className={`${styles.baseStyle} ${styles.buildViewDate}`}
                />
              </div>
            </div>
            <div className={`${styles.filterBarTrace}`}>
              <div className={`${styles.timeline_tabs}`}>
                {" "}
                <div
                  className={`${styles.baseStyle} ${styles.filterBarElem}`}
                />
              </div>
              <div className={`${styles.timeline_tabs}`}>
                <div
                  className={`${styles.baseStyle} ${styles.filterBarElem}`}
                />
              </div>
              <div className={`${styles.timeline_tabs}`}>
                <div
                  className={`${styles.baseStyle} ${styles.filterBarElem}`}
                />
              </div>
              <div className={`${styles.timeline_tabs}`}>
                <div
                  className={`${styles.baseStyle} ${styles.filterBarElem}`}
                />
              </div>
              <div className={`${styles.timeline_tabs}`}>
                <div
                  className={`${styles.baseStyle} ${styles.filterBarElem}`}
                />
              </div>
              <div className={`${styles.timeline_tabs}`}>
                <div
                  className={`${styles.baseStyle} ${styles.filterBarElem}`}
                />
              </div>
            </div>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((_, index) => {
              return (
                <div className="timeline-wrapper" key={`firstLoad-${index}`}>
                  <div className={`${styles.timeline_item}`}>
                    <div
                      className={`${styles["traceCol-2"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.buildViewDate}`}
                      />
                      <div
                        className={`${styles.baseStyle} ${styles.buildViewTime}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-5"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.buildViewName}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-3"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.buildViewSummary}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-2"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.buildViewStatus}`}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );

      // break;

      case "testViewInfinite":
        return (
          <div className={`${styles.traceParent}`}>
            {[1, 2, 3].map((_, index) => {
              return (
                <div
                  className="timeline-wrapper"
                  key={`testViewInfinite-${index}`}
                >
                  <div className={`${styles.testView_item}`}>
                    <div
                      className={`${styles["traceCol-2"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.testViewDate}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-5"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.testViewName}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-5"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles["traceCol-6"]} ${styles.traceCol}`}
                      >
                        <div
                          className={`${styles.baseStyle} ${styles.testViewSummary}`}
                        />
                      </div>
                      <div
                        className={`${styles["traceCol-6"]} ${styles.traceCol}`}
                      >
                        <div
                          className={`${styles.baseStyle} ${styles.testViewSummary}`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );

      case "commandlog":
        return (
          <div className="timeline-wrapper">
            <div className={`${styles.commandlog}`}>
              <div className={`${styles["traceCol-2"]} ${styles.traceCol}`}>
                <div className={`${styles.baseStyle} ${styles.testViewDate}`} />
              </div>
              <div className={`${styles["traceCol-5"]} ${styles.traceCol}`}>
                <div className={`${styles.baseStyle} ${styles.testViewName}`} />
              </div>
              <div className={`${styles["traceCol-5"]} ${styles.traceCol}`}>
                <div className={`${styles["traceCol-6"]} ${styles.traceCol}`}>
                  <div
                    className={`${styles.baseStyle} ${styles.testViewSummary}`}
                  />
                </div>
                <div className={`${styles["traceCol-6"]} ${styles.traceCol}`}>
                  <div
                    className={`${styles.baseStyle} ${styles.testViewSummary}`}
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case "testHistory":
        return (
          <div className={`${styles.traceParent}`}>
            {Array(2)
              .fill(0)
              .map((_, index) => {
                return (
                  <div className="timeline-wrapper">
                    <div className={`${styles.commandlog}`}>
                      <div
                        className={`${styles["traceCol-2"]} ${styles.traceCol}`}
                      >
                        <div
                          className={`${styles.baseStyle} ${styles.testViewDate}`}
                        />
                      </div>
                      <div
                        className={`${styles["traceCol-5"]} ${styles.traceCol}`}
                      >
                        <div
                          className={`${styles.baseStyle} ${styles.testViewName}`}
                        />
                      </div>
                      <div
                        className={`${styles["traceCol-5"]} ${styles.traceCol}`}
                      >
                        <div
                          className={`${styles["traceCol-6"]} ${styles.traceCol}`}
                        >
                          <div
                            className={`${styles.baseStyle} ${styles.testViewSummary}`}
                          />
                        </div>
                        <div
                          className={`${styles["traceCol-6"]} ${styles.traceCol}`}
                        >
                          <div
                            className={`${styles.baseStyle} ${styles.testViewSummary}`}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        );

      case "groupedTest":
        return (
          <div className={`${styles.traceParent}`}>
            {Array(4)
              .fill(0)
              .map((_, index) => {
                return (
                  <div
                    className={`${styles.groupedTest}`}
                    key={`groupedTest-${index}`}
                  >
                    <div
                      className={`${styles["traceCol-8"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.testViewDate}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-4"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.testViewDate}`}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        );

      case "sidebarGroupedTest":
        return (
          <div className={`${styles.traceParent}`}>
            {Array(4)
              .fill(0)
              .map((_, index) => {
                return (
                  <div
                    className={`${styles.sidebarGroupedTest}`}
                    key={`sidebarGroupedTest-${index}`}
                  >
                    <div
                      className={`${styles["traceCol-8"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.testViewDate}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-4"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.testViewDate}`}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        );

      case "debuggerParentLoader":
        return (
          <div className={`${styles.traceParent}`}>
            {[1, 2, 3, 4].map((_, index) => {
              return (
                <div
                  className="timeline-wrapper"
                  key={`debuggerParentLoader-${index}`}
                >
                  <div className={`${styles.testView_item}`}>
                    <div
                      className={`${styles["traceCol-2"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.testViewDate}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-5"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.testViewName}`}
                      />
                    </div>
                    <div
                      className={`${styles["traceCol-4"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles["traceCol-6"]} ${styles.traceCol}`}
                      >
                        <div
                          className={`${styles.baseStyle} ${styles.testViewSummary}`}
                        />
                      </div>
                      <div
                        className={`${styles["traceCol-6"]} ${styles.traceCol}`}
                      >
                        <div
                          className={`${styles.baseStyle} ${styles.testViewSummary}`}
                        />
                      </div>
                    </div>
                    <div
                      className={`${styles["traceCol-1"]} ${styles.traceCol}`}
                    >
                      <div
                        className={`${styles.baseStyle} ${styles.testViewName}`}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      case "testInfoDetail":
        return (
          <div className={`${styles.traceParent}`}>
            <div>
              <div
                className={`${styles.baseStyle} ${styles.testDurationSummary}`}
              />
              <div className={`${styles.baseStyle} ${styles.testVideo}`} />
              {[1, 2, 3, 4].map(() => {
                return (
                  <div className="timeline-wrapper">
                    <div className={`${styles.testView_item}`}>
                      <div
                        className={`${styles["traceCol-5"]} ${styles.traceCol}`}
                      >
                        <div
                          className={`${styles.baseStyle} ${styles.testViewDate}`}
                        />
                      </div>
                      <div
                        className={`${styles["traceCol-2"]} ${styles.traceCol}`}
                      >
                        <div
                          className={`${styles.baseStyle} ${styles.testViewName}`}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      case "testLogsDetail":
        return (
          <div className={`${styles.traceParent}`}>
            <div>
              {[1, 2, 3, 4, 5, 6, 7, 8].map(() => {
                return (
                  <div className="timeline-wrapper">
                    <div className={`${styles.testView_item}`}>
                      <div
                        className={`${styles["traceCol-5"]} ${styles.traceCol}`}
                        xs={5}
                      >
                        <div
                          className={`${styles.baseStyle} ${styles.testViewDate}`}
                        />
                      </div>
                      <div
                        className={`${styles["traceCol-2"]} ${styles.traceCol}`}
                      >
                        <div
                          className={`${styles.baseStyle} ${styles.testViewName}`}
                        />
                      </div>
                      <div
                        className={`${styles["traceCol-4"]} ${styles.traceCol}`}
                      >
                        <div
                          className={`${styles.baseStyle} ${styles.testViewName}`}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      case "search":
        return (
          <div className={`${styles.traceParent}`}>
            <div>
              {Array(length)
                .fill("")
                .map((_, index) => {
                  return (
                    <div className="timeline-wrapper" key={index}>
                      <div className={styles.search}>
                        <div
                          className={`${styles.baseStyle} ${styles.searchStatus}`}
                        />
                        <div
                          className={`${styles.baseStyle} ${styles.searchName}`}
                        />
                        <div
                          className={`${styles.baseStyle} ${styles.searchDate}`}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        );

      case "tableLoader":
        return (
          <div className={`${styles.traceParent} ${styles.tableLoader}`}>
            <div>
              {Array(length)
                .fill("")
                .map((_, index) => {
                  return (
                    <div className="timeline-wrapper" key={index}>
                      <div className={`${styles.testView_item}`}>
                        {columnConfig.map((columnSize, idx) => {
                          const traceClassName = `traceCol-${columnSize}`;
                          return (
                            <div
                              className={`${styles.traceCol} ${styles[traceClassName]}`}
                              key={idx}
                            >
                              <div
                                className={`${styles.baseStyle} ${styles.tableColumn}`}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        );

      default:
        return <div />;
        break;
    }
  }
}

export default ComponentTraceLoader;
